var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap_item",class:{
    'wrap_item-accordion': _vm.$vuetify.breakpoint.smAndDown,
    active: _vm.accordionStatus,
    'wrap_item-accordion--error':
      _vm.$vuetify.breakpoint.smAndDown && _vm.$slots.default[0].context.$refs[_vm.refChildName] &&
      !_vm.$slots.default[0].context.$refs[_vm.refChildName].valid,
  }},[_c('div',{staticClass:"wrap_item_head",on:{"click":function($event){_vm.accordionStatus = !_vm.accordionStatus}}},[_c('div',{staticClass:"wrap_container"},[_c('h2',{staticClass:"wrap_title f32 fw300"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('IconAccordion',{staticClass:"arrow"})],1)]),_c('div',{staticClass:"wrap_item_body"},[_c('div',{staticClass:"wrap_container"},[_c('div',{staticClass:"itemBox"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }